import getAPI from "@API/index";
import { downloadFile } from "@Dao/api";
import { IntegrationFile, FileType } from "@Constants/types";

export const getIntegrationFiles = async (): Promise<IntegrationFile[]> => {
  const response = await getAPI().request<{
    success: boolean;
    data: IntegrationFile[];
    message: string | null;
    errors: string[] | null;
  }>({
    url: "/api/file/integration-files",
    method: "GET",
  });

  if (response.success && response.data) {
    return response.data;
  }

  throw new Error(response.message || "Failed to fetch integration files");
};

export const uploadIntegrationFile = async (
  file: File,
  fileType: FileType
): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileType", fileType.toString());

  await getAPI().request({
    url: "/api/file/upload",
    method: "POST",
    data: formData,
    successText: "integrationFiles.uploadSuccess",
    errorText: "integrationFiles.uploadError",
  });
};

export const downloadIntegrationFile = async (fileId: string): Promise<void> => {
  await downloadFile(`/api/file/${fileId}/file`);
};
